import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import UpgradeToGetStarted from '../../../components/UpgradeToGetStarted/UpgradeToGetStarted'

const Performance = () => {
    return (
        <div>
            <div>
                <UpgradeToGetStarted
                    imageSrc="./assets/images/app-activity/insights/insights-no-data.png"
                    imageAlt="insights no data"
                    heading="Insights"
                    description="Boost your team’s productivity with powerful analytics — track trends across members and projects, identify top and low performers, and uncover time spent on unproductive apps and URLs."
                    lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
                    promoText="Schedule a call with our sales team to discover more about Insights."
                    buttonText="Upgrade to get started"
                />
            </div>

            {/* <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #DFDFDF', borderRadius: '8px' }}>
                <img src='./assets/images/app-activity/insights/insights-no-data.png' className='img-fluid' alt='insights no data' />
                <Typography sx={{ fontSize: '32px', color: '#1A1F36', fontWeight: '600', margin: '48px auto 12px' }}>Insights</Typography>
                <Typography sx={{ fontSize: '16px', color: '#373737', fontWeight: '400', maxWidth: '550px' }}>Boost your team’s productivity with powerful analytics — track trends across members and projects, identify top and low performers, and uncover time spent on unproductive apps and URLs.</Typography>

                <Box sx={{
                    display: { xs: 'block', sm: 'block', md: 'block', lg: 'flex' },
                    alignItems: { sm: 'center' }, // Only applies from 'sm' and up
                    justifyContent: { sm: 'space-between' },
                    gap: { xs: 2, sm: 3 }, gap: 22, backgroundColor: '#0076FE0A', padding: '20px 12px', border: '1px solid #0076FE', borderRadius: '8px', margin: '48px auto', height: { md: 'auto', lg: '80px' }
                }}>
                    <Typography sx={{ whiteSpace: 'nowrap', fontSize: '16px', fontWeight: '500', color: '#0076FE', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <img src='./assets/images/app-activity/insights/lock-icon.svg' className='img-fluid' alt='Lock Icon' />
                        Schedule a call with our sales team to discover more about Insights.</Typography>
                    <button style={{ whiteSpace: 'nowrap', fontSize: '16px', fontWeight: '600', color: '#FFFFFF', padding: '8px 24px', backgroundColor: '#0076FE', borderRadius: '100px' }}>Upgrade to get started</button>
                </Box>
            </div> */}
        </div>
    )
}

export default Performance
